import React, { useEffect, useState, useContext } from 'react';
import { Form, Input, Button, Spin, message, Divider, Row, Col, Upload, Select } from 'antd';
import { UploadOutlined, PictureOutlined } from '@ant-design/icons';
import { LoginContext } from '../../../../context/loginContext';
import { GlobalContext } from '../../../../context/globalContext';
import CArticuloSupermercadoEmpresa from './CArticuloSupermercadoEmpresa';
import CArticuloIndumentariaEmpresa from './CArticuloIndumentariaEmpresa';
import CArticuloElectronicaEmpresa from './CArticuloElectronicaEmpresa';
import CArticuloElectrodomesticoEmpresa from './CArticuloElectrodomesticoEmpresa';
import CArticuloMuebleEmpresa from './CArticuloMuebleEmpresa';
import CArticuloJugueteEmpresa from './CArticuloJugueteEmpresa';
import CArticuloCosmeticoEmpresa from './CArticuloCosmeticoEmpresa';
import CImagenArtEmpresa from './CImagenArtEmpresa';

const { Option } = Select;

const CDetalleArticuloEmpresa = ({ articuloId, onSave }) => {
  const { user } = useContext(LoginContext);
  const { categorias, tipoFraccionamientos } = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [categoriaTipo, setCategoriaTipo] = useState(null);
  const [detalleCompleto, setDetalleCompleto] = useState(null);
  const [imagenes, setImagenes] = useState([null, null, null]);
  const [urls, setUrls] = useState(['', '', '']);
  const [nivel1, setNivel1] = useState([]);
  const [nivel2, setNivel2] = useState([]);
  const [nivel3, setNivel3] = useState([]);
  const [nivel4, setNivel4] = useState([]);

  useEffect(() => {
    if (categorias.length > 0) {
      setNivel1(categorias.filter(c => !c.cat_padre_id));
    }
  }, [categorias]);

  useEffect(() => {
    if (articuloId) fetchDetalle();
  }, [articuloId]);

  const fetchDetalle = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/articulos/${articuloId}/detalle`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
      if (!res.ok) throw new Error('Error al obtener detalle');
      const data = await res.json();

      const tipoMap = {
        1: 'supermercado',
        2: 'indumentaria',
        3: 'electronica',
        4: 'electrodomestico',
        5: 'mueble',
        6: 'juguete',
        7: 'cosmetico'
      };

      const valores = {
        ...data,
        ...(data.detalle || {})
      };

      // reconstruir jerarquía desde la categoría final
      const getCategoriaRama = (catId) => {
        const rama = [];
        let actual = categorias.find(c => c.cat_id === catId);
        while (actual) {
          rama.unshift(actual);
          actual = categorias.find(c => c.cat_id === actual.cat_padre_id);
        }
        return rama;
      };

      const rama = getCategoriaRama(data.aem_categoria_id);
      const [cat1, cat2, cat3, cat4] = rama;

      setNivel1(categorias.filter(c => !c.cat_padre_id));
      setNivel2(cat1 ? categorias.filter(c => c.cat_padre_id === cat1.cat_id) : []);
      setNivel3(cat2 ? categorias.filter(c => c.cat_padre_id === cat2.cat_id) : []);
      setNivel4(cat3 ? categorias.filter(c => c.cat_padre_id === cat3.cat_id) : []);

      form.setFieldsValue({
        ...valores,
        nivel1: cat1?.cat_id,
        nivel2: cat2?.cat_id,
        nivel3: cat3?.cat_id,
        nivel4: cat4?.cat_id
      });

      setUrls([
        data.aem_imagen || '',
        data.aem_imagen2 || '',
        data.aem_imagen3 || ''
      ]);

      setCategoriaTipo(data.tipo_nombre?.toLowerCase() || tipoMap[data.aem_tipo_id]);
      setDetalleCompleto(valores);
    } catch (error) {
      message.error('Error al cargar el detalle');
    } finally {
      setLoading(false);
    }
  };


  const obtenerPadreRaiz = (id) => {
    let actual = categorias.find(c => c.cat_id === id);
    while (actual && actual.cat_padre_id) {
      actual = categorias.find(c => c.cat_id === actual.cat_padre_id);
    }
    return actual?.cat_id;
  };

  const obtenerPadreIntermedio = (id) => {
    const cat = categorias.find(c => c.cat_id === id);
    return cat?.cat_padre_id;
  };

  const onNivel1Change = (value) => {
    const hijos = categorias.filter(cat => cat.cat_padre_id === value);
    setNivel2(hijos);
    setNivel3([]);
    setNivel4([]);
    form.setFieldsValue({ nivel2: undefined, nivel3: undefined, nivel4: undefined });
  };

  const onNivel2Change = (value) => {
    const hijos = categorias.filter(cat => cat.cat_padre_id === value);
    setNivel3(hijos);
    setNivel4([]);
    form.setFieldsValue({ nivel3: undefined, nivel4: undefined });
  };

  const onNivel3Change = (value) => {
    const hijos = categorias.filter(cat => cat.cat_padre_id === value);
    setNivel4(hijos);
    form.setFieldsValue({ nivel4: undefined });
  };


  const onFinish = async (values) => {
    try {
      const payload = {
        ...detalleCompleto,
        ...values,
        tipo_id: detalleCompleto?.aem_tipo_id,
        categoria_id: values.nivel4 || values.nivel3
      };

      const formData = new FormData();
      Object.entries(payload).forEach(([key, val]) => {
        if (val !== undefined && val !== null) {
          formData.append(key, val);
        }
      });

      imagenes.forEach((file, i) => {
        if (file) {
          formData.append(`imagen${i === 0 ? '' : i + 1}`, file);
        } else if (urls[i]) {
          formData.append(`imagen${i === 0 ? '' : i + 1}_url`, urls[i]);
        }
      });

      const res = await fetch(`${process.env.REACT_APP_API_URL}/articulos/${articuloId}`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        body: formData,
      });

      if (!res.ok) throw new Error('Error al actualizar');
      message.success('Artículo actualizado');
      if (onSave) onSave();
    } catch (error) {
      message.error('Error al actualizar');
    }
  };

  const renderFormByTipo = () => {
    switch (categoriaTipo) {
      case 'supermercado': return <CArticuloSupermercadoEmpresa form={form} />;
      case 'indumentaria': return <CArticuloIndumentariaEmpresa form={form} />;
      case 'electronica': return <CArticuloElectronicaEmpresa form={form} />;
      case 'electrodomestico': return <CArticuloElectrodomesticoEmpresa form={form} />;
      case 'mueble': return <CArticuloMuebleEmpresa form={form} />;
      case 'juguete': return <CArticuloJugueteEmpresa form={form} />;
      case 'cosmetico': return <CArticuloCosmeticoEmpresa form={form} />;
      default: return null;
    }
  };

  if (loading) return <Spin style={{ marginTop: '4rem' }} />;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'auto' }}>
      <div style={{ width: '90%', maxWidth: 1100 }}>
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Divider orientation="left">Categoría</Divider>
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item name="nivel1" label="Nivel 1" rules={[{ required: true }]}>
                <Select onChange={onNivel1Change} placeholder="Seleccione">
                  {nivel1.map(cat => (
                    <Option key={cat.cat_id} value={cat.cat_id}>{cat.cat_nombre}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="nivel2" label="Nivel 2" rules={[{ required: true }]}>
                <Select onChange={onNivel2Change} placeholder="Seleccione">
                  {nivel2.map(cat => (
                    <Option key={cat.cat_id} value={cat.cat_id}>{cat.cat_nombre}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="nivel3" label="Nivel 3" rules={[{ required: true }]}>
                <Select onChange={onNivel3Change} placeholder="Seleccione">
                  {nivel3.map(cat => (
                    <Option key={cat.cat_id} value={cat.cat_id}>{cat.cat_nombre}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="nivel4" label="Nivel 4">
                <Select placeholder="Seleccione">
                  {nivel4.map(cat => (
                    <Option key={cat.cat_id} value={cat.cat_id}>{cat.cat_nombre}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

          </Row>
          <Divider orientation="left">Inofrmación</Divider>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="aem_nombre" label="Nombre">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="aem_sku" label="SKU">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="aem_marca" label="Marca">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="aem_codbarra" label="Código de barras">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="aem_tipo_unidad" label="Tipo de Unidad" rules={[{ required: true }]}>
                <Select placeholder="Seleccione el tipo de unidad">
                  {tipoFraccionamientos.map((tipo) => (
                    <Option key={tipo.tfr_id} value={tipo.tfr_id}>
                      {tipo.tfr_nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="aem_descripcion_corta" label="Descripción Corta">
                <Input.TextArea rows={2} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="aem_descripcion_larga" label="Descripción Larga">
                <Input.TextArea rows={2} />
              </Form.Item>
            </Col>
          </Row>

          {renderFormByTipo()}

          <Divider orientation="left"><PictureOutlined /> Imágenes</Divider>
          <Row gutter={24}>
            {[0, 1, 2].map((index) => (
              <Col span={8} key={index}>
                <div style={{ padding: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.05)', backgroundColor: '#fafafa', marginBottom: 16, minHeight: 150 }}>
                  <Form.Item label={`Imagen ${index === 0 ? 'Principal' : index + 1} - URL`}>
                    <Input
                      placeholder="https://..."
                      value={urls[index]}
                      onChange={(e) => {
                        const updated = [...urls];
                        updated[index] = e.target.value;
                        setUrls(updated);
                        setImagenes(prev => {
                          const updatedFiles = [...prev];
                          updatedFiles[index] = null;
                          return updatedFiles;
                        });
                      }}
                    />
                  </Form.Item>
                  <Form.Item label="O subir archivo">
                    <Upload
                      beforeUpload={(file) => {
                        const updated = [...imagenes];
                        updated[index] = file;
                        setImagenes(updated);
                        setUrls(prev => {
                          const updatedUrls = [...prev];
                          updatedUrls[index] = '';
                          return updatedUrls;
                        });
                        return false;
                      }}
                      showUploadList={false}
                    >
                      <Button icon={<UploadOutlined />}>Subir Imagen</Button>
                    </Upload>
                  </Form.Item>
                </div>
              </Col>
            ))}
          </Row>

          <CImagenArtEmpresa
            files={imagenes}
            urls={urls}
            setFiles={setImagenes}
            setUrls={setUrls}
          />

          <Form.Item style={{ textAlign: 'center', marginTop: 32 }}>
            <Button 
              type="primary" 
              htmlType="submit"
              style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
            >
              Guardar cambios
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default CDetalleArticuloEmpresa;